export enum LicenseeEntityType {
  business = 'business',
  individual = 'individual',
}
